import { Dispatch } from "redux";
import { AuthInterface } from "../interfaces/auth";

export const setAuthData = (data: AuthInterface) => {
    return (dispatch: Dispatch) => {
        dispatch({ type: "SET_AUTH", payload: data });
    };
};
